export function clearSession() {
  // CTF auth truth is the HttpOnly application session cookie.
}
